
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(1 1)"}},[_c('path',{attrs:{"fill":"#E4E8F8","fill-rule":"nonzero","d":"M21.19 5.57a2.711 2.711 0 0 1-2.71-2.71v.794a2.711 2.711 0 1 0 5.42 0V2.86a2.711 2.711 0 0 1-2.71 2.71zM.657 20.452H24v2.928H.657z"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M.1 0v23.9H24M24 19.88h-.63M22.522 19.88h-.63M21.045 19.88h-.631M19.567 19.88h-.63M18.09 19.88h-.631M16.612 19.88h-.631M15.134 19.88H14.5M13.654 19.88h-.63M12.177 19.88h-.631M10.699 19.88h-.63M9.221 19.88h-.63M7.743 19.88h-.63M6.266 19.88h-.631M4.788 19.88h-.63M3.31 19.88h-.63M1.833 19.88h-.631M16.681 10.094l2.446-3.923M10.036 14.876l4.814-2.961M1.202 16.413l6.377-.698"}}),_c('circle',{attrs:{"cx":"21.189","cy":"2.86","r":"2.711","stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M20.5 2.86l.543.544.928-.929"}}),_c('circle',{attrs:{"cx":"8.906","cy":"15.57","r":"1","stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5"}}),_c('circle',{attrs:{"cx":"15.981","cy":"11.219","r":"1","stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5"}})])])
          )
        }
      }
    